import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { StatusBadge } from "@/components/StatusBadge";
import { toast } from "sonner";

export default function SuperFeatureFlags() {
    const [flags, setFlags] = useState([]);

    const load = async () => { const { data } = await api.get("/platform/flags"); setFlags(data); };
    useEffect(() => { load(); }, []);

    const toggle = async (f) => {
        try { await api.patch(`/platform/flags/${f.id}`, { enabled: !f.enabled }); await load(); }
        catch { toast.error("Failed"); }
    };

    return (
        <>
            <Topbar title="Feature Flags" subtitle="Roll out features gradually" />
            <div className="flex-1 overflow-auto p-6">
                <div className="akm-card divide-y divide-border overflow-hidden">
                    {flags.map((f) => (
                        <div key={f.id} className="flex items-center gap-3 p-4" data-testid={`flag-${f.key}`}>
                            <div className="min-w-0 flex-1">
                                <div className="flex items-center gap-2">
                                    <span className="font-mono text-[12px] text-muted-foreground">{f.key}</span>
                                    <StatusBadge status={f.scope === "global" ? "active" : "trial"} label={f.scope} />
                                </div>
                                <div className="mt-0.5 text-sm font-medium">{f.name}</div>
                                <div className="text-[12px] text-muted-foreground">{f.description}</div>
                            </div>
                            <button
                                onClick={() => toggle(f)}
                                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${f.enabled ? "bg-primary" : "bg-muted"}`}
                                data-testid={`flag-toggle-${f.key}`}
                            >
                                <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${f.enabled ? "translate-x-6" : "translate-x-1"}`} />
                            </button>
                        </div>
                    ))}
                    {flags.length === 0 && <div className="py-12 text-center text-sm text-muted-foreground">No flags</div>}
                </div>
            </div>
        </>
    );
}
